'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipCodeToLatLng = exports.msaCreditStatById = exports.msaById = exports.msas = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _deep = require('helpers/deep');

var flattenMsa = function flattenMsa(msa) {
  return {
    id: msa.id,
    name: msa.name,
    alias: msa.alias,
    city: msa.city,
    display_name: msa.display_name,
    default_location: msa.default_location,
    currency_code: msa.currency_code,
    currency_format: msa.currency_format,
    country_code: (0, _deep.deepExtract)('country.code', msa),
    country_id: (0, _deep.deepExtract)('country.id', msa),
    price: msa.price,
    package_purchase: msa.package_purchase,
    timezone: msa.timezone,
    version: msa.version
  };
};

var msas = exports.msas = (0, _sagaTools.makeEntityScaffold)('SAGA.API.MSAS', function (client, options) {
  return client.msas.getList(options).then(function (data) {
    return data.msas.map(flattenMsa);
  });
});

var msaById = exports.msaById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.MSA_BY_ID', function (client, id) {
  return client.msas.getById(id).then(flattenMsa);
}, { defaultKey: 1 });

var msaCreditStatById = exports.msaCreditStatById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.MSA_CREDIT_STAT_BY_ID', function (client, msaId) {
  return client.msas.getCreditStats(msaId);
}, { defaultKey: 1 });

var zipCodeToLatLng = exports.zipCodeToLatLng = (0, _sagaTools.makeEntityScaffold)('SAGA.API.ZIP_CODE_TO_LATLNG', function (client, countryCode, zip) {
  return client.locations.getByPostalCode(zip, {
    country_code: countryCode
  });
}, { defaultKey: [1, 2] });